module.exports = __webpack_public_path__ + "static/media/Founding Your First Company_ A Panel.6ae6057e.png";